import { render, staticRenderFns } from "./FXOptions.vue?vue&type=template&id=e500e2f2&scoped=true&"
import script from "./FXOptions.vue?vue&type=script&lang=js&"
export * from "./FXOptions.vue?vue&type=script&lang=js&"
import style0 from "./FXOptions.vue?vue&type=style&index=0&lang=css&"
import style1 from "./FXOptions.vue?vue&type=style&index=1&lang=scss&"
import style2 from "./FXOptions.vue?vue&type=style&index=2&id=e500e2f2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e500e2f2",
  null
  
)

export default component.exports